module.exports = __webpack_public_path__ + "static/media/profile-style-img.9cf6a25f.png";